import React, { useMemo } from "react";
import { noop } from "@common/helpers/function";
import { NO_TIER_SENTINEL } from "@common/constants/organization";
import {
    FilterMultiselect,
    FilterMultiselectOption,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { useOrganizationServices } from "@api/organizationService.api";
import { BaseFilterProps } from "../../lib";
import styles from "../TransactionStatusFilter/TransactionStatusFilter.module.scss";
const NO_TIER_OPTION: FilterMultiselectOption = {
    value: NO_TIER_SENTINEL,
    label: "No tier",
    searchableLabel: "No tier",
};

export const OrgServiceFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const { data: services = [] } = useOrganizationServices();

    const options = useMemo<FilterMultiselectOption[]>(
        () => [
            NO_TIER_OPTION,
            ...services.map((service) => ({
                value: service.id,
                label: service.name,
                searchableLabel: service.name,
            })),
        ],
        [services],
    );

    const value = useMemo(() => {
        const ids = filters.orgServiceIds ?? [];
        return filters.orgServiceNoTier ? [NO_TIER_SENTINEL, ...ids] : ids;
    }, [filters.orgServiceIds, filters.orgServiceNoTier]);

    return (
        <div className={styles.filter}>
            <FilterMultiselect
                inDropdown={false}
                options={options}
                value={value}
                onChange={(val) => {
                    const selected = val.map(String);
                    const hasNoTier = selected.includes(NO_TIER_SENTINEL);
                    const realIds = selected.filter(
                        (id) => id !== NO_TIER_SENTINEL,
                    );
                    onChange({
                        orgServiceIds: realIds.length ? realIds : undefined,
                        orgServiceNoTier: hasNoTier || undefined,
                    });
                }}
                name="orgService"
                onBlur={noop}
            />
        </div>
    );
};
